import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgScan = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 3a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v4a1 1 0 0 0 2 0V4h4a1 1 0 0 0 1-1ZM3 15a1 1 0 0 0-1 1v4a2 2 0 0 0 2 2h4a1 1 0 1 0 0-2H4v-4a1 1 0 0 0-1-1Zm19-7a1 1 0 1 1-2 0V4h-4a1 1 0 1 1 0-2h4a2 2 0 0 1 2 2v4Zm-7 13a1 1 0 0 0 1 1h4a2 2 0 0 0 2-2v-4a1 1 0 1 0-2 0v4h-4a1 1 0 0 0-1 1Zm6-8H3a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2Z", fill: color }));
};
export default factorySvgIcon(SvgScan);
//# sourceMappingURL=SvgScan.js.map